/** Environment helpers — runtime (env.js), Vite (VITE_*) and CRA (REACT_APP_*) fallback. */
const runtime = typeof window !== 'undefined' ? window.__ENV__ : undefined

export const APP_NAME =
  runtime?.VITE_APP_NAME ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_NAME) ||
  process.env.REACT_APP_NAME ||
  'SamLibroCompras'

export const APP_VERSION =
  runtime?.VITE_APP_VERSION ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_VERSION) ||
  process.env.REACT_APP_VERSION ||
  '0.2.0'

export const API_URL =
  runtime?.VITE_API_URL ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:5000/api'

export const IS_DEV =
  (typeof import.meta !== 'undefined' && import.meta.env?.DEV) ||
  process.env.NODE_ENV === 'development'
